import { useSelector } from 'react-redux';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { formatPostalCodeForDisplay } from '@makemydeal/dr-shared-ui-utils';
import { useCustomerCardContext } from '../../CustomerFormContext';
import { AddressContent } from './address.styles';
import { extractAddressFields, getFormattedAddress } from './address.utils';
import type { Address, AddressType } from './address.utils';

type AddressSummaryProps = {
    type: AddressType;
};

/**
 * Read-only view of a single address block.
 * Derives the formatted display lines from CustomerFormContext.formValues.
 */
const AddressSummary = ({ type }: AddressSummaryProps) => {
    const { formValues } = useCustomerCardContext();
    const isPostalCodeDigitsOnlyValidationEnabled = useSelector(featureToggleSelectors.isPostalCodeDigitsOnlyValidationEnabled);

    const source = type === 'billing' ? formValues.billingAddress ?? {} : formValues;
    const address = extractAddressFields(source as Address);
    const displayAddress = isPostalCodeDigitsOnlyValidationEnabled
        ? { ...address, zip: formatPostalCodeForDisplay(address.zip) }
        : address;
    const lines = getFormattedAddress(displayAddress);

    return (
        <AddressContent>
            {lines.map((line, i) => (
                <Typography key={i} data-testid="address-line" variant="body-sm" className="pii">
                    {line}
                </Typography>
            ))}
        </AddressContent>
    );
};

export default AddressSummary;
